import AbstractShape from "@/Models/Shapes/AbstractShape";
import { PreviewShapeFactory } from "@/Models/Shapes/PreviewShapeFactory";
import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";
import { convertUnits } from "@/functions/numbers";

export default {
	namespaced: true,
	getters: {
		getInstance: ( state, getters, rootState, { measurements } ): AbstractShape => {
			return ( new PreviewShapeFactory() ).get( {
				shape: 'polygon',
				dimensions: measurements.dimensions,
				modifiers: measurements.modifiers,
			} );
		},
		cutoutPrimitives: ( state, getters, rootState, { cutoutMeasurements } ): object => {
			return {
				...convertUnits( cutoutMeasurements.dimensions[ 'polygon' ] ),
				side_amount: cutoutMeasurements.modifiers.side_amount,
			};
		},
		getCutoutArea: ( state, getters, rootState, { cutoutMeasurements, getArea } ): number => {
			return getArea( 'polygon', cutoutMeasurements.dimensions[ 'polygon' ] );
		},
		isCenteredShape: (): boolean => true,
		getArea: ( state, getters, rootState, { getArea, parsedDimensions } ): object => {
			return getArea( 'polygon', parsedDimensions );
		},
	},
};
